const FALLBACK_LANGUAGE = "en";

const createDetachedIntegration = (editor) => ({
  getLanguage: () => editor?.locale?.uiLanguage ?? FALLBACK_LANGUAGE,
  destroy: () => {},
});

const MATH_TYPE_PLUGIN_NAME = "MathType";

export const patchMathTypePlugin = (builtinPlugins) => {
  const MathTypePlugin = builtinPlugins?.find?.(
    (plugin) => plugin.pluginName === MATH_TYPE_PLUGIN_NAME,
  );
  if (!MathTypePlugin) return;

  const originalInit = MathTypePlugin.prototype.init;
  const originalAddIntegration = MathTypePlugin.prototype._addIntegration;

  MathTypePlugin.prototype._addIntegration = function () {
    return (
      originalAddIntegration.call(this) ??
      createDetachedIntegration(this.editor)
    );
  };

  MathTypePlugin.prototype.init = function () {
    const isDetached = !this.editor?.sourceElement;
    const previousInstance = window.WirisPlugin?.currentInstance ?? null;
    originalInit.call(this);
    if (isDetached) {
      if (window.WirisPlugin)
        window.WirisPlugin.currentInstance = previousInstance;
      this._ownIntegration = null;
      return;
    }
    this._ownIntegration = window.WirisPlugin?.currentInstance ?? null;
  };

  MathTypePlugin.prototype.destroy = function () {
    this._ownIntegration?.destroy();
    this._ownIntegration = null;
  };
};
